import script from "./CustomerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerCard.vue?vue&type=script&setup=true&lang=js"

import "./CustomerCard.vue?vue&type=style&index=0&id=4c4f00b2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c4f00b2"]])

export default __exports__